import React from 'react';
import { Divider, Typography } from '@mui/material';
import sim from '../../../../../images/Agri-info/crops/Bean_শিম.jpg';
import useDocumentTitle from '../../../../../hooks/useDocumentTitle';

const SimInfo = () => {

    // dynamic title
    useDocumentTitle("শিম");

    return (

        <div className=" rounded-3 bg-white my-4 px-5">
            <Typography
                sx={{
                    textAlign: "center",
                    pb: 2,
                    pt: 3,
                    fontWeight: 600,
                    color: 'rgb(37, 36, 36, 0.83)'
                }}
                variant="h3"
                noWrap
                component="div"
            >
                শিম
            </Typography>
            <Divider />

            <div className="card mt-4 mb-3 border-0 rounded-0">
                <div className="row g-0">
                    <div className="col-md-4">
                        <img src={sim} className="img-fluid rounded-0 h-100" alt="..." />
                    </div>
                    <div className="col-md-8">
                        <div className="card-body text-start ">
                            <p>শিম একটি প্রোটিন সমৃদ্ধ সবজি। এর বিচিও পুষ্টিকর সবুজ হিসেবে খাওয়া হয়। এটি জমি ছাড়াও রাস্তার ধারে, আইলে, ঘরের চালে, গাছেও ফলানো  যায়।</p>

                            <p className="card-text fw-bold">মাটিঃ</p>
                            <p className="card-text">দোআশ ও বেলে দোআশ মাটিতে শিম  ভাল ফলন হয়।</p>

                            <p className="card-text fw-bold">জাতঃ</p>
                            <p className="card-text">দেশে পঞ্চাশটিরও বেশি স্থানীয় শিমের জাত আছে। এগুলোর মধ্যে উল্লেখযোগ্য হল বাইনতারা, হাতিকান, চ্যাপ্টাশিম, ধলা শিম, পুটিশিম, ঘৃত কাঞ্চন, সীতাকুন্ডু, নলডক </p>

                        </div>
                    </div>
                </div>
            </div>

            <div className='text-start pb-5'>

                <p>ইত্যাদি। বারি শিম ১, বারি শিম ২, বিইউ শিম ৩, ইপসা শিম ১, ইপসা শিম ২, একস্ট্রা আর্লি, আইরেট ইত্যাদি আধুনিক উচ্চ ফলনশীল জাত। নিচে কয়েকটি আধুনিক জাতের শিমের পরিচয় দেয়া হল-</p>
                <p><b>বারি শিম ১- </b>মাঝারি আগাম জাত। আষাঢ় থেকে ভাদ্র মাসে বীজ বপন করতে হয়। প্রতিটি শিমের ওজন ১০-১১ গ্রাম, শিমে ৪-৫ টি বীজ হয়, গাছ প্রতি ৪৫০-৫০০ টি শিম ধরে। জীবনকাল ২০০-২২০ দিন। হেক্টর প্রতি ফলন ২০-২২ টন।</p>
                <p><b>বারি শিম ২- </b>আগাম জাত। আষাঢ় থেকে ভাদ্র মাসে বীজ বপন করতে হয়। প্রতিটি শিমের ওজন ১০-১৩ গ্রাম, শিমে ৪-৫ টি বীজ হয়, গাছ প্রতি ৩৮০-৪০০ টি শিম ধরে। জীবনকাল ১৯০-২১০ দিন। হেক্টর প্রতি ফলন ১০-১২ টন। </p>
                <p><b>বিইউ শিম ৩- </b>সারা বছর চাষ করা যায়। গ্রীষ্ম মৌসুমেও চাষের উপযোগী। শিমের রঙ বেগুনি। প্রতিটি শিমে গড়ে ৫ টি বীজ হয়। হেক্টর প্রতি ফলন ৭-৮ টন।</p>
                <p><b>ইপসা শিম ১- </b>সারা বছর চাষ করা যায়। গ্রীষ্ম মৌসুমেও চাষের উপযোগী। শিমের রঙ বেগুনি। প্রতিটি শিমে গড়ে ৫ টি বীজ হয়। হেক্টর প্রতি ফলন ৫-১০ টন।</p>
                <p><b>ইপসা শিম ২- </b>সারা বছর চাষ করা যায়। গ্রীষ্ম মৌসুমেও চাষের উপযোগী। শিমের রঙ সাদাটে সবুজ। প্রতিটি শিমে গড়ে ৪ টি বীজ হয়। হেক্টর প্রতি ফলন ৭-৮ টন।</p>

                <p className="card-text fw-bold">বীজ বপনের সময়ঃ</p>
                <p className="card-text">আষাঢ়  থেকে ভাদ্র মাস পর্যন্ত বীজ বোনার  উপযুক্ত সময়।</p>

                <p className="card-text fw-bold">জমি তৈরিঃ</p>
                <p className="card-text">বেশী জমিতে আবাদ করা হলে কয়েকটি চাষ ও মই দেয়া ভাল। মাদার দৈর্ঘ্য, প্রস' ও গভীরতার আকার ৪৫ সেন্টিমিটার রাখতে হবে।</p>

                <p className="card-text fw-bold">মাদার দুরত্বঃ </p>
                <p className="card-text">এক মাদা থেকে অন্য মাদার দুরত্ব ৩.০ মিটার।<br />প্রতি মাদার জন্য সারের পরিমাণ-</p>
                <p>গোবর ১০ কেজি, খৈল ২০০ গ্রাম, ছাই ২ কেজি, টিএসপি ১০০ গ্রাম, এমওপি ৫০ গ্রাম। মাদা তৈরি করার সময় এসব সার প্রয়োগ করতে হবে। চারা গজালে ১৪ থেকে ২১ দিন পর পর দু’কিসি-তে ৫০ গ্রাম করে ইউরিয়া ও ৫০ গ্রাম করে এমওপি সার প্রয়োগ করতে হবে।</p>

                <p className="card-text fw-bold">বীজ বপনের নিয়মঃ </p>
                <p className="card-text">প্রতি মাদায় ৪-৫ টি বীজ বুনতে হয়। বীজ বপনের আগে ১০-১২ ঘন্টা বীজ ভিজিয়ে নিতে হবে। প্রতিটি মাদায় ২-৩ টি করে সুস' চারা রেখে বাকী চারা তুলে ফেলতে হয়।</p>

                <p className="card-text fw-bold">পরিচর্যাঃ</p>
                <p className="card-text">কোন অবস্থাতেই গাছের গোড়ায় পানি যাতে না জমে সেদিকে খেয়াল রাখতে হবে। শুষ্ক মৌসুমে জমিতে প্রয়োজন মত সেচ দিতে হবে। মাঝে মাঝে মাটি নিড়ানি দিয়ে আলগা করে দিতে হবে। এছাড়া গাছ যখন ১৫ থেকে ২০ সেন্টিমিটার লম্বা হবে তখন মাদার গাছের গোড়ার পাশে বাঁশের ডগা মাটিতে পুঁতে বাউনির ব্যবস্থা করতে হবে।</p>

                <p className="card-text fw-bold">পোকামাকড় ব্যবস্থাপনা:</p>
                <p className="card-text">শিমের সবচেয়ে ক্ষতিকর পোকা হল ফল ছিদ্রকারী পোকা ও জাব পোকা। চারা অবস্থায় পাতা সুড়ঙ্গকারী পোকা মহা ক্ষতিকর। লাল ক্ষুদ্র মাকড়ও অনেক সময় বেশ ক্ষতি করে থাকে ফুল ফুটলে থ্রিপস ক্ষতি করতে পারে। ফল পেকে এলে বিন পড বাগ বা শিমের গান্ধি পোকা ক্ষতি করে। আইপিএম পদ্ধতি অনুসরণ করে এসব পোকামাকড় দমনের ব্যসস্থা নিতে হবে।</p>

                <p className="card-text fw-bold">রোগ ব্যবস্থাপনা:</p>
                <p className="card-text">শিমের সবচেয়ে মারাত্মক রোগ দু’টি- মোজেইক ও অ্যানথ্রাকনোজ।</p>

                <p className="card-text fw-bold">ফসল সংগ্রহঃ</p>
                <p className="card-text">আশ্বিন-কার্তিক মাসে  ফুল ধরে। ফুল ফোটার ২০-২৫ দিন পর ফসল সংগ্রহ করা যায়। ৪ মাসেরও বেশী সময় ধরে ফল দেয়। ফলন প্রতি শতকে ৩৫-৭৫ কেজি, হেক্টর প্রতি ১০-১৫ টন।</p>

            </div>
        </div >

    );
};

export default SimInfo;